var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountMenuBookings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookings-icon",
    transform: "translate(-1407 -2684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    transform: "translate(1407 2684)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons_Building_Line",
    "data-name": "icons/Building/Line",
    transform: "translate(1408.494 2685.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.81,1.66H1.66V8.3H5.81a.83.83,0,0,0,.83-.83V2.49A.83.83,0,0,0,5.81,1.66ZM0,0V9.96H5.81A2.49,2.49,0,0,0,8.3,7.47V2.49A2.49,2.49,0,0,0,5.81,0Z",
    transform: "translate(10.3 8.64)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    "data-name": "Shape",
    transform: "translate(13.62 11.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_10BBA20D-242F-4BF6-A775-BE8079BD4A4F",
    "data-name": "10BBA20D-242F-4BF6-A775-BE8079BD4A4F",
    d: "M1.66.83a.83.83,0,1,0-.83.83A.83.83,0,0,0,1.66.83Z",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_37459F4A-D08A-438B-B786-91F7E0A7009E",
    "data-name": "37459F4A-D08A-438B-B786-91F7E0A7009E",
    d: "M1.66.83a.83.83,0,1,0-.83.83A.83.83,0,0,0,1.66.83Z",
    transform: "translate(0 2.49)",
    fill: "#6b6b95"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M2.49,16.6A2.49,2.49,0,0,1,0,14.11V2.49A2.49,2.49,0,0,1,2.49,0H7.47A2.49,2.49,0,0,1,9.96,2.49V16.6Zm0-14.94H7.47a.83.83,0,0,1,.83.83V14.94H6.64v-.83a.83.83,0,0,0-.83-.83H4.15a.83.83,0,0,0-.83.83v.83H2.49a.83.83,0,0,1-.83-.83V2.49A.83.83,0,0,1,2.49,1.66Z",
    transform: "translate(2 2)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-4",
    "data-name": "Shape",
    transform: "translate(5.32 5.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "AC7A467B-27B2-4B84-A684-B563B5AC7107",
    d: "M2.49,0a.83.83,0,0,1,0,1.66H.83A.83.83,0,0,1,.83,0Z",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_45960FC5-0232-4157-88B4-951787C26F20",
    "data-name": "45960FC5-0232-4157-88B4-951787C26F20",
    d: "M2.49,0a.83.83,0,0,1,0,1.66H.83A.83.83,0,0,1,.83,0Z",
    transform: "translate(0 3.32)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_13CD75A9-9162-486C-9314-D61BACC97540",
    "data-name": "13CD75A9-9162-486C-9314-D61BACC97540",
    d: "M3.32.83A.83.83,0,0,0,2.49,0H.83a.83.83,0,0,0,0,1.66H2.49A.83.83,0,0,0,3.32.83Z",
    transform: "translate(0 6.64)",
    fill: "#6b6b95"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenuBookings);
export default __webpack_public_path__ + "static/media/accountMenuBookings.95b2ae427405e8a527c1e064a7cfcf59.svg";
export { ForwardRef as ReactComponent };